import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
}), 'SlideshowOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SlideshowOutlined.js
// module id = 6274
// module chunks = 2